import { render, staticRenderFns } from "./select-staff-by-department.vue?vue&type=template&id=50789928&"
import script from "./select-staff-by-department.vue?vue&type=script&lang=js&"
export * from "./select-staff-by-department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports